var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.286 3.956c.29.36.558.74.823 1.214a9.75 9.75 0 0 1 1.22 5.623 9.405 9.405 0 0 1-2.177 5.252 10.732 10.732 0 0 1-1.486 1.46c-1.808 1.454-3.952 2.172-6.09 2.152-2.137-.02-4.266-.778-6.045-2.275a10.636 10.636 0 0 1-1.45-1.486 9.352 9.352 0 0 1-1.966-4.418 9.53 9.53 0 0 1 .5-4.828c.567-1.522 1.435-2.878 2.568-3.94a8.693 8.693 0 0 1 6.92-2.314.596.596 0 0 1-.13 1.185 7.445 7.445 0 0 0-2.583.158 7.494 7.494 0 0 0-3.393 1.838c-.998.937-1.765 2.137-2.27 3.488a8.332 8.332 0 0 0-.439 4.226 8.203 8.203 0 0 0 1.717 3.857c.402.5.834.941 1.288 1.324 1.561 1.313 3.423 1.977 5.29 1.995s3.744-.612 5.333-1.89a9.47 9.47 0 0 0 1.323-1.297 8.217 8.217 0 0 0 1.898-4.59 8.566 8.566 0 0 0-1.07-4.937 7.759 7.759 0 0 0-.815-1.178l-.086 2.392a.593.593 0 0 1-.616.573.593.593 0 0 1-.573-.615l.139-3.812a.593.593 0 0 1 .615-.573c.021 0 .04.003.06.005l3.695.519a.595.595 0 1 1-.164 1.18l-2.036-.288Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon-reset.cf0add63de56f3114c32a73cdb890f3c.svg";
export { ForwardRef as ReactComponent };